import { CardIntegration } from '@/partials/cards';
import PropTypes from 'prop-types';
const Integrations = ({
  items: customItems
}) => {
  const defaultItems = [{
    logo: 'jira.svg',
    path: '/account/billing/basic',
    name: 'Jira',
    description: 'Project management for agile teams, tracking issues and tasks.',
    actions: <div className="switch switch-sm">
      <input type="checkbox" name="param" defaultChecked value="1" readOnly />
    </div>
  }, {
    logo: 'inferno.svg',
    path: '/account/billing/enterprise',
    name: 'Inferno',
    description: 'Ensures healthcare app compatibility with FHIR standards.',
    actions: <div className="switch switch-sm">
      <input type="checkbox" name="param" value="1" readOnly />
    </div>
  }, {
    logo: 'evernote.svg',
    path: '/account/billing/plans',
    name: 'Evernote',
    description: 'Organizes personal and professional documents, ideas, tasks.',
    actions: <div className="switch switch-sm">
      <input type="checkbox" name="param" defaultChecked value="1" readOnly />
    </div>
  }, {
    logo: 'gitlab.svg',
    path: '/account/billing/history',
    name: 'Gitlab',
    description: 'DevOps platform for code control, project management, CI/CD.',
    actions: <div className="switch switch-sm">
      <input type="checkbox" name="param" defaultChecked value="1" readOnly />
    </div>
  }, {
    logo: 'google-webdev.svg',
    path: '/account/security/get-started',
    name: 'Google webdev',
    description: 'Tools for building quality web experiences, focusing on performance.',
    actions: <div className="switch switch-sm">
      <input type="checkbox" name="param" defaultChecked value="1" readOnly />
    </div>
  }, {
    logo: 'invision.svg',
    path: '/account/security/overview',
    name: 'Invision',
    description: 'Digital design platform for prototyping and design workflow.',
    actions: <div className="switch switch-sm">
      <input type="checkbox" name="param" value="1" readOnly />
    </div>
  }, {
    logo: 'duolingo.svg',
    path: '/account/security/allowed-ip-addresses',
    name: 'Duolingo',
    description: 'Interactive exercises for fun, effective language learning.',
    actions: <div className="switch switch-sm">
      <input type="checkbox" name="param" value="1" readOnly />
    </div>
  }, {
    logo: 'google-analytics-2.svg',
    path: '/account/security/privacy-settings',
    name: 'Google Analytics',
    description: 'Insights into website traffic and marketing effectiveness.',
    actions: <div className="switch switch-sm">
      <input type="checkbox" name="param" value="1" readOnly />
    </div>
  }];
  const items = customItems?.length ? customItems : defaultItems;
  const renderItem = (item, index) => {
    if (item.customContent) {
      return <div key={index}>{item.customContent}</div>;
    }

    return <CardIntegration
      icon={item.icon}
      logo={item.logo}
      path={item.path}
      name={item.name}
      description={item.description}
      descriptionContent={item.descriptionContent}
      metadata={item.metadata}
      actions={item.actions}
      onNameClick={item.onNameClick}
      onView={item.onView}
      onSecondaryView={item.onSecondaryView}
      secondaryViewLabel={item.secondaryViewLabel}
      onEdit={item.onEdit}
      onDelete={item.onDelete}
      deleteDisabled={item.deleteDisabled}
      deleteTooltip={item.deleteTooltip}
      editFirst={item.editFirst}
      primaryActionLabel={item.primaryActionLabel}
      primaryActionContent={item.primaryActionContent}
      onPrimaryAction={item.onPrimaryAction}
      primaryActionDisabled={item.primaryActionDisabled}
      primaryActionLoading={item.primaryActionLoading}
      key={index}
    />;
  };
  return <div id="integrations_cards">
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-5 lg:gap-7.5">
      {items.map((item, index) => {
        return renderItem(item, index);
      })}
    </div>
  </div>;
};

Integrations.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.node,
    logo: PropTypes.string,
    path: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    descriptionContent: PropTypes.node,
    actions: PropTypes.node,
    customContent: PropTypes.node,
    onNameClick: PropTypes.func,
    onView: PropTypes.func,
    onSecondaryView: PropTypes.func,
    secondaryViewLabel: PropTypes.string,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    deleteDisabled: PropTypes.bool,
    deleteTooltip: PropTypes.string,
    editFirst: PropTypes.bool,
    primaryActionLabel: PropTypes.string,
    primaryActionContent: PropTypes.node,
    onPrimaryAction: PropTypes.func,
    primaryActionDisabled: PropTypes.bool,
    primaryActionLoading: PropTypes.bool
  }))
};

export { Integrations };
